import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ShiftManagementService from "../../services/ShiftManagementService";

const initialState = {
    data: null,
    paginatedData: null,
    selectedShiftData:null,
    status: 'idle'
};

export const fetchPaginatedShifts = createAsyncThunk('paginatedShifts', async () => {
    const response = await ShiftManagementService.getShifts(true);
    return response;
});

export const fetchShifts = createAsyncThunk('shifts', async () => {
    const response = await ShiftManagementService.getShifts(false);
    return response;
});

export const fetchSelectedShiftData = createAsyncThunk('selectedShift', async (shiftId) => {
    const response = await ShiftManagementService.getShiftById(shiftId);
    return response;
});

export const ShiftManagementSlice = createSlice({
    name: "shifts",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchPaginatedShifts.pending, (state) => {
            state.status = "loading";
        }).addCase(fetchPaginatedShifts.fulfilled, (state, action) => {
            state.status = "idle";
            state.paginatedData = action.payload;
        }).addCase(fetchShifts.pending, (state) => {
            state.status = "loading";
        }).addCase(fetchShifts.fulfilled, (state, action) => {
            state.status = "idle";
            state.data = action.payload?.data;
        }).addCase(fetchSelectedShiftData.pending, (state) => {
            state.status = "loading";
        }).addCase(fetchSelectedShiftData.fulfilled, (state, action) => {
            state.status = "idle";
            state.selectedShiftData = action.payload;
        });
    }
});

export const selectPaginatedShifts = (state) => {
    return state.shifts.paginatedData;
};

export const selectShifts = (state) => {
    return state.shifts.data;
};

export const selectedShiftSelector = (state) => {
    return state.shifts.selectedShiftData
}

export default ShiftManagementSlice.reducer;
